/**
 * /dashboard/offboarding/new — New offboarding cycle
 * (G4.6 — POST /api/v1/offboarding/cycles).
 *
 * HR-admin only — both at the gate here and at the backend.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/offboarding/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { OffboardingRoleGate } from "@/components/offboarding/offboarding-role-gate";
import { CycleForm } from "@/components/offboarding/cycle-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/offboarding/new")({
  component: NewOffboardingCycleRoute,
});

function NewOffboardingCycleRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <HrModuleShell
      title="New offboarding cycle"
      description="Open an exit cycle for an employee — tasks will be seeded automatically."
    >
      <OffboardingRoleGate>
        <Card className="max-w-2xl">
          <CardContent className="pt-6">
            <CycleForm />
          </CardContent>
        </Card>
      </OffboardingRoleGate>
    </HrModuleShell>
  );
}
